import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

import I18nLink from 'widgets/I18nLink';
import { getKey } from 'utils';

import './StaticContentSection.css';

const StaticContentSection = ({
  content,
  ctaTitle,
  staticPages,
  onCtaClick
}) => (
  <Grid>
    <div className="section static-section">
      <div
        className="static-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <div className="static-cta-button">
        <Button
          bsSize="large"
          bsStyle="success"
          onClick={onCtaClick}
        >
          {ctaTitle}
        </Button>
      </div>

      <ul className="static-links-list">
        {staticPages.map((page) => (
          <li
            key={page.id}
            className="static-links-item"
          >
            <I18nLink
              className="btn static-links-link"
              to={`/${page.url}/`}
            >
              {getKey(page, 'title')}
            </I18nLink>
          </li>
        ))}
      </ul>
    </div>
  </Grid>
);

StaticContentSection.propTypes = {
  content: PropTypes.string,
  ctaTitle: PropTypes.string,
  staticPages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string
  })),
  onCtaClick: PropTypes.func
};

StaticContentSection.defaultProps = {
  content: null,
  ctaTitle: null,
  staticPages: [],
  onCtaClick: null
};

export default StaticContentSection;



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/StaticContentSection/StaticContentSection.js